import {Supplier, SupplierState} from "@/modules/supplier/types";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {getSupplier} from "@/services/supplier"

export const state: SupplierState = {
  supplier: {
    id: "",
    id_company: "",
    id_auth: "",
    name: "",
    address: "",
    tax_id: "",
    email: "",
  },
}

const actions: ActionTree<SupplierState, RootState> = {
  async GET_SUPPLIER(_, id) {
    return await getSupplier(id);
  }
}

const mutations: MutationTree<SupplierState> = {
  SET_SUPPLIER(state, supplier: Supplier){
    state.supplier = supplier
  }
}

const getters: GetterTree<SupplierState, RootState> = {
  SUPPLIER(state): Supplier {
    const {supplier} = state;
    return {...supplier};
  }
}

export const supplier: Module<SupplierState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
